import styled from '@emotion/styled';
import { boxSizes, colors, fontSizes, gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const PoweredLabelWrapper = styled.div<{ withInfo?: boolean, isMobile?: boolean, pageType?: string }>`
    display: flex;
    align-items: center;
    gap: ${gutterSizes.base};
    padding: 0 ${props => props.pageType === 'vip' && props.isMobile ? '0' : gutterSizes.base};
    background-color: ${props => props.withInfo ? 'transparent' : colors.branch5};
    border-radius: ${boxSizes.borderRadius4};
    width: fit-content;
    margin-top: ${props => props.withInfo ? gutterSizes.base : 0};

    && .hint-tooltip {
        position: relative;
    }
        
    && .hint-tooltip-content {
        text-align: left;
    }
`;

export const PoweredText = styled.span`
    font-size: ${fontSizes.small};
    color: ${colors.fgButtonDisabled};
`;

export const LogoImage = styled.img<{ withInfo?: boolean }>`
    width: 46.5px;
    height: 14px;

    ${props => props.withInfo && `
        margin-right: -6px;
    `}
`;
